<template>
  <div class="container pb-[75px] px-[15px] mx-auto">
    <div class="flex flex-col items-center">
      <div class="font-primary font-medium text-dark-blue text-[40px] pb-[25px]">{{ contact_form_title }}</div>
      <img class="mb-[70px]" v-bind:src="icon_dotted_line_light_blue" alt="">
    </div>
    <ValidationObserver ref="formObserver">
      <form v-on:submit.prevent="onSubmit">
        <div class="grid grid-cols-12 gap-[15px] lg:gap-[30px]">
          <div class="col-span-12 lg:col-span-4">
            <ValidationProvider rules="name_required" v-slot="{ errors }">
              <input type="text" class="w-full font-primary text-[18px] py-[15px] px-[15px] border-[1px] rounded-none outline-none" v-model="name" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_1" v-bind:class="errors.length ? 'placeholder-light-blue border-red-500' : 'placeholder-dark-blue border-border-grey'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 lg:col-span-4">
            <ValidationProvider rules="email_required|email_valid" v-slot="{ errors }">
              <input type="email" class="w-full font-primary text-[18px] py-[15px] px-[15px] border-[1px] rounded-none outline-none" v-model="email" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_2" v-bind:class="errors.length ? 'placeholder-light-blue border-red-500' : 'placeholder-dark-blue border-border-grey'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 lg:col-span-4">
            <ValidationProvider rules="phone_required" v-slot="{ errors }">
              <input type="text" class="w-full font-primary text-[18px] py-[15px] px-[15px] border-[1px] rounded-none outline-none" v-model="phone" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_3" v-bind:class="errors.length ? 'placeholder-light-blue border-red-500' : 'placeholder-dark-blue border-border-grey'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 lg:col-span-6">
            <ValidationProvider rules="subject_required" v-slot="{ errors }">
              <input type="text" class="w-full font-primary text-[18px] py-[15px] px-[15px] border-[1px] rounded-none outline-none" v-model="subject" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_4" v-bind:class="errors.length ? 'placeholder-light-blue border-red-500' : 'placeholder-dark-blue border-border-grey'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 lg:col-span-6">
            <ValidationProvider rules="found_required" v-slot="{ errors }">
              <select class="w-full font-primary text-[18px] py-[15px] px-[15px] border-[1px] rounded-none outline-none" v-model="found" v-bind:class="errors.length ? 'text-light-blue border-red-500' : 'text-dark-blue border-border-grey'">
                <option selected value="">{{ contact_placeholder_5 }}</option>
                <option v-for="option in contact_select_options" v-bind:value="option.value">{{ option.name }}</option>
              </select>
            </ValidationProvider>
          </div>
          <div class="col-span-12">
            <ValidationProvider rules="message_required" v-slot="{ errors }">
              <textarea rows="6" class="w-full font-primary text-[18px] py-[15px] px-[15px] border-[1px] rounded-none outline-none" v-model="message" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_6" v-bind:class="errors.length ? 'placeholder-light-blue border-red-500' : 'placeholder-dark-blue border-border-grey'"></textarea>
            </ValidationProvider>
          </div>
          <div class="col-span-12 flex items-center justify-center">
            <div v-on:click="onSubmit" class="inline-flex items-center bg-dark-blue py-[15px] px-[15px] cursor-pointer transition-all ease-in-out duration-300 hover:bg-light-blue">
              <div class="font-primary text-[18px] text-white">{{ contact_label_submit }}</div>
              <img v-if="!loading" loading="lazy" class="self-center ml-[15px]" v-bind:src="icon_arrow_right_white" alt="">
              <svg v-if="loading" class="animate-spin ml-[15px] w-[20px] h-[20px] text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-[25%]" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-[75%]" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import axios from 'axios';

extend('name_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_1
});

extend('email_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_2
});

extend('email_valid', {
  ...email,
  message: window.contact_us_script_data.contact_error_3
});

extend('phone_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_4
});

extend('subject_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_5
});

extend('found_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_6
});

extend('message_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_7
});

export default {
  name: 'ContactForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      wp_ajax: window.contact_us_script_data.wp_ajax,
      wp_nonce: window.contact_us_script_data.wp_nonce,
      wp_action: 'submit_contact_form',
      recaptcha_token: '',
      loading: false,
      contact_form_title: window.contact_us_script_data.contact_form_title,
      contact_label_submit: window.contact_us_script_data.contact_label_submit,
      icon_arrow_right_white: window.contact_us_script_data.icon_arrow_right_white,
      icon_dotted_line_light_blue: window.contact_us_script_data.icon_dotted_line_light_blue,
      contact_placeholder_1: window.contact_us_script_data.contact_placeholder_1,
      contact_placeholder_2: window.contact_us_script_data.contact_placeholder_2,
      contact_placeholder_3: window.contact_us_script_data.contact_placeholder_3,
      contact_placeholder_4: window.contact_us_script_data.contact_placeholder_4,
      contact_placeholder_5: window.contact_us_script_data.contact_placeholder_5,
      contact_placeholder_6: window.contact_us_script_data.contact_placeholder_6,
      contact_select_options: window.contact_us_script_data.contact_select_options,
      name: '',
      email: '',
      phone: '',
      subject: '',
      found: '',
      message: '',
    };
  },
  methods: {
    async onSubmit () {
      await this.$recaptchaLoaded();
      this.recaptcha_token = await this.$recaptcha('submit_contact_form');
      this.$refs.formObserver.validate().then(success => {
        if (success) {
          this.loading = true;
          let formData = new FormData();
          formData.append('wp_nonce', this.wp_nonce);
          formData.append('action',  this.wp_action);
          formData.append('name', this.name);
          formData.append('email', this.email);
          formData.append('phone', this.phone);
          formData.append('subject', this.subject);
          formData.append('found', this.found);
          formData.append('message', this.message);
          formData.append('recaptcha_token', this.recaptcha_token);
          axios({
            method: 'POST',
            url: this.wp_ajax,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData,
          }).then(response => {
            if (response.data.status === 1) {
              this.$swal('Sent', response.data.message, 'success');
              this.name = this.email = this.phone = this.subject = this.found = this.message = '';
              this.$nextTick(() => {
                this.$refs.formObserver.reset();
              });
            } else {
              this.$swal('Error', response.data.message, 'error');
            }
            this.loading = false;
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
</style>
